import {
  STATION_1,
  STATION_2,
  STATION_3,
  STATION_4,
  WARM_UP,
} from 'utils/constants/stations';

import { createSelector } from 'reselect';

export const getStations = (state) => state.stations;

export const getStationsError = createSelector(
  getStations,
  ({ error }) => error
);

export const isStationsLoading = createSelector(
  getStations,
  ({ loading }) => loading
);

export const getSelectedStation = createSelector(
  getStations,
  ({ selectedStation }) => selectedStation
);

export const getAllStations = createSelector(getStations, (stations) => ({
  [WARM_UP]: stations[WARM_UP],
  [STATION_1]: stations[STATION_1],
  [STATION_2]: stations[STATION_2],
  [STATION_3]: stations[STATION_3],
  [STATION_4]: stations[STATION_4],
}));

export const getVisitedStations = createSelector(
  getStations,
  ({ visitedStations }) => visitedStations
);
